import type { IconProps } from '../types/IconProps.ts';
export const Code: IconProps = {
    name: 'Code',
    children: [
        `<path d="m16 6 5.86 5.86a.2.2 0 0 1 0 .28L16 18M8 6l-5.86 5.86a.2.2 0 0 0 0 .28L8 18" />`,
    ]
};